import React, { useState } from "react"
import { Table, TablePaginationConfig, Tag } from "antd"
import dayjs from "dayjs"
import { User } from "../../../../services/user-service"

type Props = {
  users: User[]
  onSelect: (user: User) => void
  loading: boolean
}
export interface TPagination {
  current: number
  pageSize: number
}

export const UserTable: React.FC<Props> = ({ users, onSelect, loading }): React.ReactElement => {
  const [pagination, setPagination] = useState<TPagination>({
    current: 1,
    pageSize: 10,
  })
  const onChange = (pagination: TablePaginationConfig) => {
    const { current, pageSize } = pagination
    setPagination((prevState: any) => ({
      ...prevState,
      current: current || 1,
      pageSize: pageSize || 10,
    }))
  }

  const userColumns = [
    {
      title: "No.",
      key: "id",
      width: "70px",
      render: (event: string, row: User, index: number) => {
        let skip = (pagination.current - 1) * pagination.pageSize
        return index + skip + 1
      },
    },
    {
      title: "Id",
      key: "id",
      width: "100px",
      render: (user: User) => <a onClick={() => onSelect(user)}>{user.id.substring(0, 5)}...</a>,
    },
    { title: "Username", dataIndex: "username", key: "username", width: "25%" },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    { title: "Email", dataIndex: "email", key: "email", width: "25%" },
    {
      title: "Update At",
      dataIndex: "updatedAt",
      width: "15%",
      key: "updatedAt",
      render: (event: string) => dayjs(event).add(543, "year").format("DD-MM-YYYY HH:mm น."),
    },
    {
      title: "Status",
      dataIndex: "active",
      key: "active",
      width: "8%",
      align: "center",
      filters: [
        {
          text: "Active",
          value: true,
        },
        {
          text: "Inactive",
          value: false,
        },
      ],
      onFilter: (value: boolean, record: any) => record.active === value,
      render: (event: boolean) => (event === true ? <Tag color="green">{`Active`}</Tag> : <Tag>{`In Active`}</Tag>),
    },
  ]
  return (
    <Table
      size="small"
      rowKey="id"
      dataSource={users}
      columns={userColumns as any}
      loading={loading}
      footer={() => `Total ${users.length} Row`}
      onChange={onChange}
    />
  )
}
